import React from "react";
import { Typography, Space, Table } from "antd";

import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

// Sample data for the scatter plot
const scatterData = [
  { distance: 0.11, price: 1.84 },
  { distance: 1.57, price: 5.0 },
  { distance: 4.42, price: 3.12 },
  { distance: 11.37, price: 3.85 },
  { distance: 3.14, price: 6.98 },
  { distance: 4.04, price: 4.25 },
  { distance: 7.07, price: 4.3 },
  { distance: 0.39, price: 2.49 },
  { distance: 0.28, price: 2.65 },
  { distance: 12.53, price: 2.93 },
  // ... add more data points as needed
  // generate different random data points for distance and price
  { distance: 0.5, price: 2.0 },
  { distance: 0.8, price: 3.0 },
  { distance: 1.2, price: 4.0 },
];

const tableColumns = [
  {
    title: "Metric",
    dataIndex: "metric",
    key: "metric",
  },
  {
    title: "Value",
    dataIndex: "value",
    key: "value",
  },
];

const tableData = [
  { key: "1", metric: "Number of Comps", value: "37" },
  { key: "2", metric: "Distance Range", value: "0.11 to 12.53 miles" },
  { key: "3", metric: "Price Range", value: "$1.74M to $6.98M" },
  { key: "4", metric: "Most Recent Sales", value: "2023-2024" },
];

const ComparableSalesAnalysis = () => {
  return (
    <CustomCard
      title={
        <Space>
          <Title level={4}>Comparable Sales Analysis</Title>
        </Space>
      }
      className="card-height"
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Text>
          Analysis of 37 comparable properties provides insights into the local
          real estate market and helps validate the subject property's
          valuation.
        </Text>
        <Title level={4}>Price vs. Distance Scatter Plot</Title>
        <ResponsiveContainer width="100%" height={300}>
          <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
            <CartesianGrid />
            <XAxis
              type="number"
              dataKey="distance"
              name="Distance"
              unit=" miles"
            />
            <YAxis type="number" dataKey="price" name="Price" unit="M" />
            <Tooltip cursor={{ strokeDasharray: "3 3" }} />
            <Scatter name="Properties" data={scatterData} fill="#8884d8" />
          </ScatterChart>
        </ResponsiveContainer>
        <Text type="secondary">
          This scatter plot shows the relationship between a property's distance
          from the subject property and its sale price.
        </Text>
        <Title level={4}>Comparable Sales Summary</Title>
        <Table
          columns={tableColumns}
          dataSource={tableData}
          pagination={false}
        />
        <Text type="secondary">
          Note: The wide range in both distance and price reflects the diverse
          nature of Malibu's real estate market, from beachfront properties to
          hillside estates.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default ComparableSalesAnalysis;
